import { Bars4Icon, Squares2X2Icon as Squares2X2IconMini } from '@heroicons/react/20/solid';
import { useEffect, useState } from 'react';
import client from '../../api/client';

function classNames(...classes) {
	return classes.filter(Boolean).join(' ');
}

export default function Images() {
	const [images, setImages] = useState([]);
	const [currentFile, setCurrentFile] = useState(null);
	const [viewType, setViewType] = useState('grid'); // State to manage view type

	const fetchImages = async () => {
		try {
			const { data } = await client.get('/ai/images');
			setImages(data.images);
		} catch (error) {
			console.error(error);
		}
	};

	useEffect(() => {
		fetchImages();
	}, []);

	return (
		<div className='flex h-full bg-white'>
			<div className='flex-1 overflow-y-auto px-6 py-8'>
				<div className='flex items-center justify-between'>
					<h1 className='text-2xl font-semibold text-gray-900'>Photos</h1>
					<div className='flex items-center gap-x-2'>
						<button
							type='button'
							className={classNames(
								'rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-inset',
								viewType === 'list'
									? 'bg-gray-200 text-gray-900 focus:ring-gray-300'
									: 'bg-gray-100 text-gray-500 hover:bg-gray-200 focus:ring-gray-300'
							)}
							onClick={() => setViewType('list')}
						>
							<Bars4Icon
								className='h-5 w-5'
								aria-hidden='true'
							/>
							<span className='sr-only'>List view</span>
						</button>
						<button
							type='button'
							className={classNames(
								'rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-inset',
								viewType === 'grid'
									? 'bg-gray-200 text-gray-900 focus:ring-gray-300'
									: 'bg-gray-100 text-gray-500 hover:bg-gray-200 focus:ring-gray-300'
							)}
							onClick={() => setViewType('grid')}
						>
							<Squares2X2IconMini
								className='h-5 w-5'
								aria-hidden='true'
							/>
							<span className='sr-only'>Grid view</span>
						</button>
					</div>
				</div>

				<section className='mt-6'>
					{viewType === 'grid' ? (
						<ul
							role='list'
							className='grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4'
						>
							{images.map((img) => (
								<li
									key={img._id}
									className='relative'
									onClick={() => setCurrentFile(img)}
								>
									<div
										className={classNames(
											img._id === currentFile?._id
												? 'ring-2 ring-blue-500'
												: 'hover:ring-2 hover:ring-gray-300',
											'overflow-hidden rounded-lg bg-gray-100'
										)}
									>
										<img
											src={img.url}
											alt={img.prompt || 'Image'}
											className='object-cover w-full h-full'
										/>
									</div>
									<p className='mt-2 text-sm text-gray-800 truncate'>{img.prompt || 'Untitled'}</p>
								</li>
							))}
						</ul>
					) : (
						<ul
							role='list'
							className='space-y-4'
						>
							{images.map((img) => (
								<li
									key={img._id}
									className='flex items-center gap-4'
									onClick={() => setCurrentFile(img)}
								>
									<img
										src={img.url}
										alt={img.prompt || 'Image'}
										className='w-16 h-16 object-cover rounded-md'
									/>
									<div>
										<p className='text-sm font-medium text-gray-900'>{img.prompt || 'Untitled'}</p>
										<p className='text-sm text-gray-600'>{img.size || 'Unknown size'}</p>
									</div>
								</li>
							))}
						</ul>
					)}
				</section>
			</div>

			{currentFile && (
				<aside className='w-96 border-l border-gray-200 bg-gray-50 px-6 py-8'>
					<div className='space-y-4'>
						<img
							src={currentFile.url}
							alt={currentFile.prompt || 'Selected Image'}
							className='w-full rounded-lg'
						/>
						<h2 className='text-lg font-semibold text-gray-900'>
							{currentFile.name || 'Selected Image'}
						</h2>
						<p className='text-sm text-gray-600'>{currentFile.size || 'Unknown size'}</p>
					</div>
				</aside>
			)}
		</div>
	);
}
